/**
 * Created by chenrozenes on 24/12/2017.
 */

export const PHYSICIAN_TYPE = 'physician';
export const TAXONOMY = 'taxonomy';
export const CLINIC = 'clinic';
